var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFutureScalability(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 48.28 48.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#7da2fe;}.cls-1,.cls-2,.cls-3{stroke:#fff;stroke-linecap:round;stroke-linejoin:round;}.cls-1,.cls-3{stroke-width:2px;}.cls-2{stroke-dasharray:0 0 3.01 3.01;}.cls-2,.cls-3{fill:none;}.cls-4{fill:url(#linear-gradient);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 15.6,
    y1: 28.15,
    x2: 24.67,
    y2: 28.15,
    gradientTransform: "matrix(1, 0, 0, 1, 0, 0)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#386aff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b86f6"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.34,3.94H14.47c-1.66,0-3,1.34-3,3v26.87c0,1.66,1.34,3,3,3h26.87c1.66,0,3-1.34,3-3V6.94c0-1.66-1.34-3-3-3,0,0,1.66,0,0,0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 4.56,
    y: 19.92,
    width: 23.53,
    height: 23.53,
    rx: 3,
    ry: 3
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 4.56,
    y1: 33.49,
    x2: 4.56,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 1,
    y1: 4.56,
    x2: 4.56,
    y2: 1
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 8.13,
    y1: 4.56,
    x2: 4.56,
    y2: 1
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 11.47,
    y1: 43.45,
    x2: 47.28,
    y2: 43.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 43.72,
    y1: 39.88,
    x2: 47.28,
    y2: 43.45
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-3",
    x1: 43.72,
    y1: 47.01,
    x2: 47.28,
    y2: 43.45
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M24.59,24.23c-.1-.24-.3-.44-.54-.54-.12-.05-.25-.08-.38-.08h-5.04c-.55,0-1,.45-1,1s.45,1,1,1h2.62l-5.36,5.36c-.39,.39-.39,1.02,0,1.41,.2,.2,.45,.29,.71,.29s.51-.1,.71-.29l5.36-5.36v2.62c0,.55,.45,1,1,1s1-.45,1-1v-5.04c0-.13-.03-.26-.08-.38Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFutureScalability);
export default __webpack_public_path__ + "static/media/future-scalability.a63e62f97a1cd57cb976f0bec506c526.svg";
export { ForwardRef as ReactComponent };